import React, { createContext, useEffect, useState } from "react";

export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);

  // عنوان السيرفر المحلي
  const API_BASE = "http://localhost/my_projects/my_app/api";

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const res = await fetch(`${API_BASE}/get_content.php`, {
          credentials: "include",
        });
        const data = await res.json();
        setContent(data);
      } catch (err) {
        console.error("Error loading content:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  return (
    <GlobalContext.Provider value={{ content, setContent, loading }}>
      {children}
    </GlobalContext.Provider>
  );
};
